export default "__VITE_ASSET__CGtUNO3v__"